import { useRef } from "react";
import { motion, useMotionValue, useScroll, useSpring, useTransform } from "framer-motion";
import { Mic, Captions, Timer } from "lucide-react";
import { PhoneDemo } from "@/components/site/PhoneDemo";

const CHIPS = [
  { icon: Mic, label: "Voce umana italiana", pos: "left-[-12%] top-[18%] sm:left-[-28%]", z: 70 },
  { icon: Captions, label: "Sottotitoli automatici", pos: "right-[-10%] top-[46%] sm:right-[-30%]", z: 90 },
  { icon: Timer, label: "Pronto in 60 secondi", pos: "left-[-6%] bottom-[30%] sm:left-[-22%]", z: 60 },
];

const RingText = () => (
  <svg viewBox="0 0 200 200" className="h-full w-full animate-spin-slow" aria-hidden>
    <defs>
      <path id="ring" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" />
    </defs>
    <text className="fill-[#111111] text-[13px] font-semibold uppercase tracking-[0.32em]">
      <textPath href="#ring">Disponibile ora · MIMIS Video Italia · Disponibile ora · Tool n.1 ·</textPath>
    </text>
  </svg>
);

export const TiltPhone = () => {
  const ref = useRef(null);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [12, -12]), { stiffness: 110, damping: 16 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-16, 16]), { stiffness: 110, damping: 16 });
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 900], [0, -110]);

  const onMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const onLeave = () => {
    mx.set(0);
    my.set(0);
  };

  return (
    <motion.div
      ref={ref}
      style={{ y }}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className="relative mx-auto w-[230px] [perspective:1400px] sm:w-[280px] lg:w-[300px]"
      data-testid="hero-phone"
    >
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[120%] w-[160%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(0,102,255,0.22),transparent_62%)]" />
      <div className="pointer-events-none absolute -right-16 -top-14 hidden h-36 w-36 sm:block">
        <RingText />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 80, rotate: -8 }}
        animate={{ opacity: 1, y: 0, rotate: 0 }}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1], delay: 0.5 }}
      >
        <motion.div style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }} className="relative">
          <PhoneDemo />
          {CHIPS.map(({ icon: Icon, label, pos, z }, i) => (
            <motion.div
              key={label}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 1.3 + i * 0.15, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              style={{ transform: `translateZ(${z}px)` }}
              className={`absolute ${pos} z-30 flex items-center gap-2 whitespace-nowrap rounded-full border border-[#e7e7ea] bg-white/90 px-3 py-2 text-xs font-semibold text-[#111111] shadow-[0_12px_30px_-12px_rgba(17,17,17,0.35)] backdrop-blur-md sm:text-[0.8rem]`}
            >
              <span className="grid h-6 w-6 place-items-center rounded-full bg-[#0066FF] text-white">
                <Icon className="h-3.5 w-3.5" />
              </span>
              {label}
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </motion.div>
  );
};
